import apiClient from "./config";
import PAYCHECK_ENDPOINTS from "./endpoints/paycheckEndpoints";

const paycheckService = {
  list: (params = {}) =>
    apiClient.get(PAYCHECK_ENDPOINTS.LIST, { params }),
  create: (data) => apiClient.post(PAYCHECK_ENDPOINTS.CREATE, data),
  update: (id, data) => apiClient.put(PAYCHECK_ENDPOINTS.UPDATE(id), data),
  remove: (id) => apiClient.delete(PAYCHECK_ENDPOINTS.REMOVE(id)),
  duplicate: (id) => apiClient.post(PAYCHECK_ENDPOINTS.DUPLICATE(id)),
  touchView: (id) => apiClient.patch(PAYCHECK_ENDPOINTS.VIEW(id)),
  calculate: (data, config) =>
    apiClient.post(PAYCHECK_ENDPOINTS.CALCULATE, data, config),
  usage: () => apiClient.get(PAYCHECK_ENDPOINTS.USAGE),
};

export default paycheckService;
